import BaseService from 'services/BaseService';
import React from 'react';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

export default class ReportService
    extends BaseService {

    static async list(param) {
        return BaseService.callAPI('report/list', param);
    }

    static async get(slug) {
        return BaseService.callAPI('report/get/' + slug );
    }

    static async run(slug, param) {
        ReportService.convertReportParams(param);
        return BaseService.callAPI('report/run/' + slug, param);
    }

    static async excel(slug, param) {
        ReportService.convertReportParams(param);
        return BaseService.callAPI('report/run-excel/' + slug, {
            ...param,
            isDownload: true
        });
    }

    static convertReportParams(param) {
        if (param.paramValues) {
            param.paramValues = { ...param.paramValues };
        }

        // Convert param values that are objects to a comma-separated string
        for (let paramName in param.paramValues) {
            let paramValue = param.paramValues[paramName];
            if (Object.prototype.toString.call(paramValue) == '[object Object]' && !Array.isArray(paramValue) && paramValue !== null) {
                paramValue = Object.keys(paramValue).join(',');
                param.paramValues[paramName] = paramValue;
            }
        }
    }

    static formatValue(value, type) {
        switch (type) {
            case 'MultiLineText':
                return (value || '').split(/,/).map((v, index) => <div key={index}>{v}</div>)
            case 'Date':
                return value ? moment(value).format('DD/MM/YYYY') : '';
            case 'Month':
                return value ? moment(value).format('MMM YYYY') : '';
            case 'Bool':
                return (value ? <span className="fa-solid fa-check"></span> : null);
            case 'URL':
                return (value ? <a href={value} target="_blank" className="btn btn-block">View</a> : null);
            case 'Tooltip':
                return (value ? <span className="fa-solid fa-eye" title={value} /> : null);
        }
        return value;
    }

}
